import { ArrowLeft } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { assetUrl } from '../../common/helpers';
import { useNavigation } from '../Common/useNavigation';
import UI from '../../common/UI';
import useDocumentTitle from '../../common/useDocumentTitle';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const { r } = useNavigation();

  useDocumentTitle(['Atleta', t('website.page_not_found')]);

  return (
    <UI.Section sc={{ compact: true }}>
      <UI.Div sc={{ textAlign: 'center', py: 8 }} style={{ textWrap: 'balance' }}>
        <img src={assetUrl('images/compass.svg')} alt={t('website.page_not_found')} height={120} />
        <UI.H2 sc={{ my: 4 }}>
          {t('website.page_not_found')}
        </UI.H2>
        <UI.LinkButton to={r('Home')}>
          <UI.Icon>
            <ArrowLeft />
          </UI.Icon>
          {' '}
          {t('home')}
        </UI.LinkButton>
      </UI.Div>
    </UI.Section>
  );
};

export default NotFoundPage;
